import { makeStyles } from '@material-ui/styles'

export default makeStyles(theme => ({
    container: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.colors.light.offWhite2,
        padding: '50px 12px 50px 12px',
        width: '100%',
        zIndex: theme.zIndexLevels.four,
        position: 'absolute',
        height: '100%',
        '@media (min-width: 768px)': {
            padding: '250px 16px 250px 16px',
        },
    },
    fadeOut: {
        visibility: 'hidden',
        opacity: 0,
    },
    successCheckMark: {
        width: 75,
        minHeight: 75,
        backgroundColor: '#14c786',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 60,
        transition: 'visibility 0s 1s, opacity 1s linear',

        '@media (min-width: 768px)': {
            width: 100,
            minHeight: 100,
            marginBottom: 275,
        },
    },
    successCheckMarkIcon: {
        fontSize: 37.5,
        color: 'white',
        '@media (min-width: 768px)': {
            fontSize: 50,
        },
    },
    successToast: {
        width: '100%',
        borderRadius: 2,
        backgroundColor: '#14c786',
        fontSize: 12,
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        color: theme.colors.white,
        padding: 12,
        textAlign: 'center',
        transition: 'visibility 0s 1s, opacity 1s linear',
    },
}))
